import lightbox from "../../assets/.npm/node_modules/lightbox2/dist/js/lightbox";

export default () => {
  window.lightbox = lightbox;
  window.lightbox.option({
    //'resizeDuration': 400,
    wrapAround: true,
  });
};
